import React from "react";

// Art-deco thin gold divider with central diamond accent
export default function ArtDecoDivider({ className = "", width = "180" }) {
    return (
        <div
            className={`flex items-center justify-center my-6 ${className}`}
            aria-hidden="true"
            data-testid="art-deco-divider"
        >
            <svg
                width={width}
                height="18"
                viewBox="0 0 200 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <line x1="0" y1="9" x2="86" y2="9" stroke="#C5A059" strokeWidth="0.8" />
                <line x1="114" y1="9" x2="200" y2="9" stroke="#C5A059" strokeWidth="0.8" />
                <rect
                    x="100"
                    y="3"
                    width="10"
                    height="10"
                    transform="rotate(45 100 9)"
                    stroke="#C5A059"
                    strokeWidth="0.8"
                    fill="none"
                />
                <rect
                    x="100"
                    y="6"
                    width="4"
                    height="4"
                    transform="rotate(45 100 9)"
                    fill="#C5A059"
                />
            </svg>
        </div>
    );
}
